import Vuex, { StoreOptions } from 'vuex'
import axios from 'axios'

import BrowserInfo from '../interfaces/BrowserInfo'
import GTMEvent from '../interfaces/GTMEvent'
import { AspenwareEvent } from '../interfaces/AspenwareEvent'
import { RootState } from './types'
import Vue from 'vue'
import { activity } from '@/Activity/store/index'
import { admin } from '@/Admin/store/index'
import { location } from '@/Location/store/index'
import { profile } from '@/Profile/store/index'
import { settings } from '@/Settings/store/index'
import { task } from '@/Task/store/index'

Vue.use(Vuex)

// Vuex structure based on https://codeburst.io/vuex-and-typescript-3427ba78cfa8

const store: StoreOptions<RootState> = {
  state: {
    destination: '',
    version: '',
    pageLoading: false,
    features: [],
    appInsights: null,
    browserInfo: null,
  },
  getters: {
    browserInfo(state) {
      return state.browserInfo
    },
    destination(state) {
      return state.destination
    },
    version(state) {
      return state.version
    },
    appInsights(state) {
      return state.appInsights
    },
    features(state) {
      return state.features
    },
    hasFeature(state) {
      return (featureName) => {
        return !!state.features.find((f) => f === featureName)
      }
    },
  },
  mutations: {
    setBrowserInfo(state, browserInfo) {
      state.browserInfo = browserInfo
    },
    setDestination(state, destination) {
      state.destination = destination
    },
    setVersion(state, version) {
      state.version = version
    },
    setAppInsights(state, appInsights) {
      state.appInsights = appInsights
    },
    setPageLoading(state, loading) {
      state.pageLoading = loading
    },
    setFeatures(state, features) {
      state.features = features
    },
  },
  actions: {
    trackEvent(context, event: GTMEvent) {
      const theEvent = {
        ...event,
        destination: context.state.destination,
      }
      Vue.gtm.trackEvent(theEvent)
    },
    async fetchArrivalVersion(context) {
      if (context.state.version) return // Already fetched
      try {
        const { data } = await axios.get('/api/system/info')
        const systemInfo = typeof data === 'string' ? JSON.parse(data) : data
        const version = systemInfo?.Arrival?.ArrivalBuildNbr || 'unknown'
        context.commit('setVersion', version)
      } catch (error) {
        console.warn('Failed to fetch Arrival version:', error)
        context.commit('setVersion', 'unknown')
      }
    },
    async trackAspenwareEvent(context, eventName: string) {
      // Ensure version is loaded before tracking
      if (!context.state.version) {
        await context.dispatch('fetchArrivalVersion')
      }
      const aspenwareEvent: AspenwareEvent = {
        event: eventName,
        aspenware_data: {
          aspenware_platform: 'Arrival',
          aspenware_version: context.state.version,
        },
      }
      Vue.gtm.trackEvent(aspenwareEvent)
    },
  },
  modules: {
    profile,
    location,
    settings,
    activity,
    task,
    admin,
  },
}

export default new Vuex.Store<RootState>(store)
